import React from 'react';
import { LayoutTemplate, Home, Inbox, QrCode } from 'lucide-react';

const MobileTabs = ({ activeTab, setActiveTab }) => {
  const tabs = [
    { id: 'portfolio', label: 'Website', icon: LayoutTemplate },
    { id: 'properties', label: 'Properties', icon: Home },
    { id: 'responses', label: 'Responses', icon: Inbox },
    { id: 'qr', label: 'QR', icon: QrCode },
  ];

  return (
    <div className="px-4 pb-3 flex items-center gap-2 overflow-x-auto">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => setActiveTab(tab.id)}
          className={`flex-shrink-0 px-3 py-1.5 rounded-full text-xs font-medium transition-colors flex items-center gap-1.5 ${
            activeTab === tab.id 
              ? 'bg-notion-text text-white' 
              : 'bg-white text-notion-text border border-notion-border'
          }`}
        >
          <tab.icon className="w-3 h-3" /> {tab.label}
        </button>
      ))}
    </div>
  );
};

export default MobileTabs;
